import { fromEnumAsString, toEnumFromString } from '../../serialization/enum-utils.js';
import { MapUtils } from '../../utility/map-utils.js';
import { DataModel, DataModelBuilder, SerializationContext, SerializedData } from '../dto/dto.js';
import { BusinessPrivacyMode } from './business-privacy-mode.js';

export class BusinessPrivacySettings extends DataModel {
  static readonly TYPE_ID: string = 'e2c60f34b67e4032a34d1e2a3a923252';

  constructor(
    public readonly privacyMode: BusinessPrivacyMode,
  ) {
    super();
  }

  get $typeId(): string {
    return BusinessPrivacySettings.TYPE_ID;
  }

  static fromMap(context: SerializationContext, map: SerializedData): BusinessPrivacySettings {
    return new BusinessPrivacySettings(
        toEnumFromString(MapUtils.get<string>(map, 'privacyMode'), BusinessPrivacyMode),
    );
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'privacyMode': fromEnumAsString(this.privacyMode),
    };
  }

  clone(): this {
    return new BusinessPrivacySettings(
        this.privacyMode,
    ) as this;
  }

  isSame(other: BusinessPrivacySettings): boolean {
    if(other === this) {
      return true;
    }

    return other.privacyMode === this.privacyMode;
  }
}

export class BusinessPrivacySettingsBuilder extends DataModelBuilder<BusinessPrivacySettings> {
  build(context: SerializationContext, map: SerializedData): BusinessPrivacySettings {
    return BusinessPrivacySettings.fromMap(context, map);
  }
}
